module.exports = __webpack_public_path__ + "static/media/630EchoStNW_2018-06-25_191.608d3643.jpg";